<template>
  <v-dialog max-width="1000px">
    <v-card>
      <v-card-title>
        <span class="headline">Cari Ekle</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="localCustomer.fullname"
                label="Adı Soyadı *"
                :rules="[rules.required]"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="localCustomer.email"
                label="Email *"
                :rules="[rules.required]"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="localCustomer.phone"
                label="Telefon *"
                :rules="[rules.required]"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="4">
              <v-text-field
                v-model="localCustomer.country"
                value="Türkiye"
                label="Ülke"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="localCustomer.city"
                label="İl"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="localCustomer.state"
                label="İlçe"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-select
                v-model="localCustomer.type"
                :items="typeItems"
                item-text="text"
                item-value="value"
                label="Tip"
                :rules="[rules.required]"
                required
              ></v-select>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="localCustomer.company"
                label="Firma Başlığı"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="localCustomer.iban"
                label="IBAN"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="localCustomer.tax_number"
                label="Vergi No"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="localCustomer.tax_office"
                label="Vergi Dairesi"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="localCustomer.description"
                label="Açıklama"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="localCustomer.address"
                label="Adres"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="submitCustomer">Ekle</v-btn>
        <v-btn color="grey" text @click="closeDialog">İptal</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watch } from "vue";
import customerService from "@/services/customerService";

export default {
  name: "CustomerForm",
  props: {
    newCustomer: {
      type: Object,
      required: true,
    },
  },
  setup(props,{ emit }) {
    // Yerel değişken tanımlama
    const localCustomer = ref({ ...props.newCustomer });

    // Prop değiştiğinde yerel değişkeni güncelle
    watch(
      () => props.newCustomer,
      (newVal) => {
        localCustomer.value = { ...newVal };
      }
    );

    const submitCustomer = async () => {
      try {
        // Müşteri kaydetme işlemleri
        await customerService.addCustomer(localCustomer.value); // Servis çağrısı
        emit("updateCustomer", localCustomer.value); // Güncellenmiş müşteri bilgilerini gönder
        emit('closeDialog');
        emit('fetchCustomerList');
      } catch (error) {
        console.error("Müşteri kaydedilirken hata oluştu:", error);
      }
    };
 
    const closeDialog = () => {
      emit("closeDialog"); // Dialogu kapatmak için bir olay yay
    };

    return {
      localCustomer,
      submitCustomer,
      closeDialog
    };
  },
  data() {
    return {
      select: { name: "Seçiniz", id: "0" },
      loading: false, // Yükleniyor durumu

      valid: false, // Form geçerliliği
      rules: {
        required: (value) => !!value || "Bu alan gereklidir.",
      },
      typeItems: [
        { title: "Müşteri", value: "normal" },
        { title: "Cari", value: "supplier" },
      ],
    };
  },

  methods: {

 
    resetNewCustomer() {
      this.localCustomer = {
        fullname: "",
        email: "",
        phone: "",
        country: "Türkiye",
        city: "",
        state: "",
        type: null,
        company: "",
        iban: "",
        tax_number: "",
        tax_office: "",
        description: "",
        address: "",
      };
    },
  },
};
</script>
